import { useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import api from '../../lib/api';

/**
 * Amber banner shown while a platform superadmin is viewing a client org via
 * a support-access (impersonation) session. The session itself is enforced
 * server-side (Redis TTL); this banner is the visible reminder + exit.
 */
export default function SupportAccessBanner() {
  const [exiting, setExiting] = useState(false);
  const active = Boolean(localStorage.getItem('sg_support_org'));
  const orgName = localStorage.getItem('sg_support_org_name') ?? 'client workspace';
  const orgDbId = localStorage.getItem('sg_support_org_dbid');

  if (!active) return null;

  const exit = async () => {
    setExiting(true);
    try {
      if (orgDbId) await api.delete(`/api/admin/orgs/${orgDbId}/impersonate`);
    } catch {
      // Session may already have expired server-side — still clean up locally.
    }
    localStorage.removeItem('sg_support_org');
    localStorage.removeItem('sg_support_org_name');
    localStorage.removeItem('sg_support_org_dbid');
    window.location.assign('/admin');
  };

  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 bg-amber-500/15 border-b border-amber-500/40 text-amber-300">
      <div className="flex items-center gap-2 text-sm">
        <ShieldAlert size={15} className="shrink-0" />
        <span>
          Support access: viewing <strong>{orgName}</strong>. This session is
          time-limited (1 hour) and audit-logged.
        </span>
      </div>
      <button
        onClick={exit}
        disabled={exiting}
        className="shrink-0 px-3 py-1 text-xs font-medium rounded-md border border-amber-500/50 hover:bg-amber-500/20 transition-colors disabled:opacity-50"
      >
        {exiting ? 'Exiting…' : 'Exit support access'}
      </button>
    </div>
  );
}
